module.exports = __webpack_public_path__ + "static/bdb2fac0bbd9bdce45e9cea897db118028af1f7ae0a655a7a2c3482062f096c0-62736a1c38c0324c4c9169e931365a1c.png";